var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"device-attributes__wrapper",staticStyle:{"border-top":"1px solid #e6e6e6"}},[_c('b-card',[_c('themed-tree',{attrs:{"items":_vm.transformedData,"trackBy":'id',"label":'label',"searchEnabled":true}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }